import { render, staticRenderFns } from "./CountdownClock.vue?vue&type=template&id=2a64528a&scoped=true&"
import script from "./CountdownClock.vue?vue&type=script&lang=js&"
export * from "./CountdownClock.vue?vue&type=script&lang=js&"
import style0 from "./CountdownClock.vue?vue&type=style&index=0&id=2a64528a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64528a",
  null
  
)

export default component.exports